module.exports = __webpack_public_path__ + "img/ai-glass.9edb24d5.png";